<template>
  <div>
    <div class="large-card" v-if="cardType">
      <router-link
        :to="$store.getters['main/getSingleUrl'](data)"
        class="large-card-img br-12"
      >
        <div class="company" v-if="_.size(_.get(data, 'logo'))">
          <div class="img-box">
            <picture>
              <source
                class="img-absolute scale br-12"
                media="(max-width: 767px)"
                :srcset="_.get(data, 'logo[0].devices.mobile')"
              />
              <source
                class="img-absolute scale br-12"
                media="(max-width: 1023px)"
                :srcset="_.get(data, 'logo[0].devices.tablet')"
              />
              <img
                class="img-absolute br-12"
                :src="_.get(data, 'logo[0].devices.desktop')"
                alt
              />
            </picture>
          </div>
        </div>
        <picture>
          <source
            class="img-absolute scale br-12"
            media="(max-width: 767px)"
            :srcset="_.get(data, 'list_cover[0].devices.mobile')"
          />
          <source
            class="img-absolute scale br-12"
            media="(max-width: 1023px)"
            :srcset="_.get(data, 'list_cover[0].devices.tablet')"
          />
          <img
            class="img-absolute br-12"
            :src="_.get(data, 'list_cover[0].devices.desktop')"
            alt
          />
        </picture>
        <div class="ending-soon" v-if="endingSoon">
          <p class="tbc-medium font-16 flex-center">
            {{ $fn.tr("Ending Soon") }}
          </p>
          <p class="sale flex-center" v-if="data.discount">
            {{ data.discount }}
          </p>
        </div>
        <div
          class="discount not-ending-soon"
          v-if="data.discount && !endingSoon"
        >
          <p class="tbc-medium font-16">{{ data.discount }}</p>
        </div>
      </router-link>
      <div class="large-content">
        <router-link
          :to="$store.getters['main/getSingleUrl'](data)"
          tag="h3"
          class="tbc-bold font-16 uppercase"
          >{{ data.title }}</router-link
        >
        <p class="tbc-medium font-16 lh-24">
          {{ data.teaser }}
        </p>
        <a :href="data.outerLinkUrl" class="get-offer animated-link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.898"
            height="20.074"
            viewBox="0 0 21.898 20.074"
          >
            <g
              id="Group_6300"
              data-name="Group 6300"
              transform="translate(-10 -13.333)"
            >
              <path
                id="Path_2943"
                data-name="Path 2943"
                d="M30.073,13.333H11.825A1.831,1.831,0,0,0,10,15.158v14.6a1.831,1.831,0,0,0,1.825,1.825v1.825H13.65V31.582h14.6v1.825h1.825V31.582A1.831,1.831,0,0,0,31.9,29.757v-14.6A1.831,1.831,0,0,0,30.073,13.333Zm0,16.424H11.825v-14.6H30.073Z"
                fill="#00a3e0"
              />
              <path
                id="Path_2944"
                data-name="Path 2944"
                d="M42.142,26.667a5.475,5.475,0,1,0,5.475,5.475A5.474,5.474,0,0,0,42.142,26.667Zm1.29,5.475L45.275,30.3a3.548,3.548,0,0,1,0,3.685Zm.553-3.133-1.843,1.842L40.3,29.007a3.549,3.549,0,0,1,3.686,0Zm-4.976,4.975a3.545,3.545,0,0,1,0-3.687l1.842,1.844Zm1.29,1.29,1.843-1.843,1.843,1.843a3.545,3.545,0,0,1-3.686,0Z"
                transform="translate(-19.367 -9.684)"
                fill="#00a3e0"
                stroke="#24313d"
                stroke-width="1"
              />
              <rect
                id="Rectangle_2182"
                data-name="Rectangle 2182"
                width="3.65"
                height="1.825"
                transform="translate(13.65 16.982)"
                fill="#00a3e0"
              />
              <circle
                id="Ellipse_214"
                data-name="Ellipse 214"
                cx="1.369"
                cy="1.369"
                r="1.369"
                transform="translate(13.65 25.195)"
                fill="#00a3e0"
              />
            </g>
          </svg>

          <span class="font-16 uppercase">
            {{
              data.outerLinkTitle ? data.outerLinkTitle : $fn.tr("get offer")
            }}
          </span>
        </a>
      </div>
    </div>

    <div class="small-card" v-else>
      <router-link
        :to="$store.getters['main/getSingleUrl'](data)"
        class="small-card-img br-12"
      >
        <picture>
          <source
            class="img-cover scale br-12"
            media="(max-width: 767px)"
            :srcset="_.get(data, 'list_cover[0].devices.mobile')"
          />
          <source
            class="img-cover scale br-12"
            media="(max-width: 1023px)"
            :srcset="_.get(data, 'list_cover[0].devices.tablet')"
          />
          <img
            class="img-cover br-12"
            :src="_.get(data, 'list_cover[0].devices.desktop')"
            alt
          />
        </picture>
        <div class="mobile-small-company" v-if="_.size(_.get(data, 'logo'))">
          <div class="img-box">
            <picture>
              <source
                class="img-absolute scale br-12"
                media="(max-width: 767px)"
                :srcset="_.get(data, 'logo[0].devices.mobile')"
              />
              <source
                class="img-absolute scale br-12"
                media="(max-width: 1023px)"
                :srcset="_.get(data, 'logo[0].devices.tablet')"
              />
              <img
                class="img-absolute br-12"
                :src="_.get(data, 'logo[0].devices.desktop')"
                alt
              />
            </picture>
          </div>
        </div>
        <div class="ending-soon" v-if="data.discount && !endingSoon">
          <p class="tbc-medium font-16">{{ data.discount }}</p>
        </div>
        <div class="discount" v-if="endingSoon">
          <p class="tbc-medium font-16">{{ $fn.tr("Ending Soon") }}</p>
        </div>
      </router-link>
      <div class="small-card-content">
        <div>
          <div class="small-company" v-if="_.size(_.get(data, 'logo'))">
            <div class="img-box">
              <picture>
                <source
                  class="img-absolute  br-12"
                  media="(max-width: 767px)"
                  :srcset="_.get(data, 'logo[0].devices.mobile')"
                />
                <source
                  class="img-absolute  br-12"
                  media="(max-width: 1023px)"
                  :srcset="_.get(data, 'logo[0].devices.tablet')"
                />
                <img
                  class="img-absolute br-12"
                  :src="_.get(data, 'logo[0].devices.desktop')"
                  alt
                />
              </picture>
            </div>
          </div>
          <router-link
            :to="$store.getters['main/getSingleUrl'](data)"
            tag="h3"
            class="tbc-bold font-16 lh-24 uppercase"
          >
            {{ data.title }}
          </router-link>
          <p class="tbc-medium lh-24 font-16">
            {{ data.teaser }}
          </p>
        </div>

        <router-link
          :to="$store.getters['main/getSingleUrl'](data)"
          class="get-offer animated-link"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              transform="translate(0 0)"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,1,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
                fill="#00aeef"
              />
            </g>
          </svg>
          <span class="font-16 uppercase">
            {{
              data.outerLinkTitle ? data.outerLinkTitle : $fn.tr("get offer")
            }}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cardType", "data"],
  data() {
    return {
      large: false
    };
  },
  computed: {
    endingSoon() {
      let date = new Date();
      let endDate = new Date(_.get(this.data, "expireDate"));
      let expireDays = _.get(this.data, "expireDays");
      if (endDate.getDate() - parseInt(expireDays) <= date.getDate()) {
        return true;
      } else {
        return false;
      }

      // return false;
    }
  }
};
</script>

<style scoped>
.large-card:hover .large-card-img .scale {
  transition: 0.4s ease;
  transform: scale(1.05);
}
.large-card-img .scale {
  transition: 0.4s ease;
}
.large-card-img {
  position: relative;
  /* padding-top: 56%; */
  padding-top: 83.5%;
  overflow: hidden;
  cursor: pointer;
  display: block;
}
.company {
  background: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  width: 120px;
  height: 52px;
  transform: translate(-50%, -0%);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  z-index: 1;
}
.img-box {
  height: 100%;
  margin: 0 15px;
}
.company img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}

.large-card-img .ending-soon {
  background: #f09f11;
  display: flex;
  align-items: center;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 50%;
  padding: 0 20px;
  /* height: 34px; */
  transform: translate(-50%, -0%);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  z-index: 1;
  width: -webkit-fill-available;
  max-width: 80%;
}
.large-card-img .ending-soon .sale {
  margin-right: -20px;
  margin-left: 20px;
  background: #fff;
  color: #f09f11;
  padding: 8px 20px;
  height: 100%;
  width: -webkit-fill-available;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.ending-soon p {
  color: #fff;
  text-align: center;
  width: -webkit-fill-available;
}
.large-card-img .discount {
  background: #f09f11;
  position: absolute;
  bottom: 0;
  left: 50%;
  padding: 6px 20px;
  transform: translate(-50%, -0%);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  z-index: 1;
  /* width: fit-content; */
}
.discount p {
  color: #fff;
  text-align: center;
}
.large-content h3 {
  margin: 31px 0 14px;
  color: var(--secondary);
}
.large-content p {
  color: var(--text-gray);
}
.large-content .get-offer {
  display: flex;
  align-items: center;
  margin-top: 28px;
  transition: 0.4s;
  cursor: pointer;
}
.large-content .get-offer span {
  color: var(--tbc-blue);
}
</style>

<style scoped>
.img-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.small-card {
  display: flex;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
  padding-bottom: 55px;
}
body[data-theme="night"] .small-card::after {
  background: rgb(255 255 255 / 5%);
}
.small-card::after {
  content: "";
  width: calc(100% + 30px);
  bottom: 0;
  position: absolute;
  left: 0;
  height: 2px;
  background: rgb(1, 4, 7, 0.05);
}
@media screen and (min-width: 1025px) {
  .small-card:hover .small-card-img img {
    transform: scale(1.05);
    transition: 0.4s ease;
  }
}
.small-card-img {
  position: relative;
  width: 160px;
  padding-top: 200px;
  max-height: 250px;
  overflow: hidden;
  transition: 0.4s ease;
}
.small-card img {
  transition: 0.4s ease;
}
.small-card-content {
  width: calc(100% - 190px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.small-company {
  width: 120px;
  height: 43px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 10px 20px 0px rgba(0, 0, 0, 0.05);
  margin-bottom: 8px;
}
.small-company img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}
.small-card .ending-soon {
  background: #686dfd;
  position: absolute;
  bottom: 0;
  left: 50%;
  padding: 6px 10px;
  width: 100%;
  transform: translate(-50%, -0%);
  border-top-left-radius: -29px;
  z-index: 1;
}
.small-card .discount {
  background: #f09f11;
  position: absolute;
  bottom: 0;
  left: 50%;
  padding: 6px 10px;
  width: 100%;
  transform: translate(-50%, -0%);
  border-top-left-radius: -29px;
  /* border-top-right-radius: 8px; */
  z-index: 1;
}
.not-ending-soon.discount {
  background: #686dfd !important;
}
.small-card-content h3 {
  margin: 0 0 21px;
  color: var(--secondary);
}
.small-card-content p {
  color: var(--text-gray);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.small-card-content p span {
  color: var(--tbc-blue);
  font-weight: bold;
}

.small-card-content .get-offer {
  display: flex;
  align-items: center;
  margin-top: 19px;
}
.mobile-img-box {
  display: none;
}
@media screen and (max-width: 1439px) and (min-width: 1024px) {
  .small-card-content p {
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .small-card-content h3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .small-card-img {
    padding-top: 162.5px;
    max-height: 162.5px;
    width: 130px;
  }
  .small-company {
    height: 28px;
  }
  .small-card-content .get-offer {
    margin-top: 17px;
  }
  .small-card-content {
    width: calc(100% - 160px);
  }
}
@media screen and (max-width: 1023px) {
  .small-card-content {
    width: calc(100% - 236px);
  }
  .small-card-img {
    position: relative;
    width: 206px;
    max-height: 257.5px;
    padding-top: 257.5px;
    overflow: hidden;
  }
}
@media screen and (max-width: 767px) {
  .small-card {
    flex-direction: column;
  }
  .small-card-content {
    width: 100%;
  }
  .small-card-img {
    position: relative;
    width: 100%;
    /* padding-top: 83.5%; */
    padding-top: 68%;
    overflow: hidden;
    margin-bottom: 19px;
  }
  .small-card-content .get-offer {
    margin-top: 48px;
  }
  .small-company {
    display: none;
  }
  .mobile-small-company {
    background: #fff;
    position: absolute;
    top: 0;
    left: 50%;
    width: 120px;
    height: 52px;
    transform: translate(-50%, -0%);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    z-index: 1;
    /* width: 120px;
        height: 43px;
        background: white;
        border-radius: 6px;
        box-shadow: 0 10px 20px 0px rgba(0,0,0,0.05);
        margin-bottom: 8px;
        display: block;
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 2 ; */
  }
  .mobile-small-company img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;
  }
  @media screen and (max-width: 413px) {
    .small-card {
      padding-bottom: 34px;
    }
    .small-card-content .get-offer {
      margin-top: 17px;
    }
  }
}
</style>
